/* eslint-disable jsx-a11y/anchor-is-valid */
import { Menu } from 'antd';
import axios from 'axios';
import { USER_SERVER } from '../../Config';
import { withRouter } from 'react-router-dom';
import { useSelector } from "react-redux";
import {LoginOutlined, UserOutlined, FilePdfOutlined, BellOutlined} from '@ant-design/icons'
import {Badge, Popover} from 'antd';
import {Link} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearNotifications } from '../../../_actions/notification_actions';

function RightMenu(props) {
  const notifications = useSelector(state => state.notification.notifications);
  const dispatch = useDispatch();
  // console.log("Notifications:", notifications);
  const logoutHandler = () => {
    axios.get(`${USER_SERVER}/logout`, { withCredentials: true }).then(response => {
      if (response.status === 200) {
        props.history.push("/login");
      } else {
        alert('Log Out Failed')
      }
    });
  };

  const clearNotification = (resumeId) => {
    dispatch(clearNotifications(resumeId));
  }
  const user = useSelector(state => state.user);
  console.log("User Data:", user);
  const menuItems1 = [
    {
      key: 'login',
      title: 'display',
      label: (
        <Link to="/login" >
          Login
        </Link>
      ),
      icon: <LoginOutlined />,
      style: {
        float: 'right'
      }
    },
    {
      key: 'register',
      title: 'display',
      label: (
        <Link to="/register">
          Sign Up
        </Link>
      ),
      icon: <UserOutlined />,
      style: {
        float: 'right'
      }
    }
  ];

  const menuItems2 = [
    {
      key: 'profile',
      title: 'Profile',
      label: (
        <Link to = "/profile">Profile</Link>
      ),
      icon: <UserOutlined />,
      style: {
        float: 'right'
      }
    },
    {
      key: 'myResume',
      title: 'myResume',
      label: (
        <Link to = "/myresume">My Resumes</Link>
      ),
      icon: <FilePdfOutlined />,
      style: {
        float: 'right'
      }
    },
    {
      key: 'logout',
      title: 'display',
      label: (
        <a onClick={logoutHandler}>Logout</a>
      ),
      icon: <LoginOutlined />,
      style: {
        float: 'right'
      }
    }, 
    {
      key: 'notifications',
      title: 'Notifications',
      label: (
        <Popover
          placement='bottomLeft'
          content={
            <div style={{display: 'flex', flexDirection: 'column', maxHeight: '300px', overflowY: 'auto'}}>
              {notifications.length > 0 ? (
                notifications.map((notification, index) => (
                  <Link key={index} style={{ marginBottom: '8px', color: notification.isRead ? 'gray' : 'black' }}
                      onClick={() => clearNotification(notification.resumeId)}
                     to={{
                      pathname: '/body',
                      state: { resumeId: notification.resumeId, userId: user.userData?._id }
                    }}>
                    {notification.message}
                  </Link>
                ))
              ) : (  
                <div>No new notifications</div>
              )}
            </div>
          }
          title="Notifications"
          trigger="click"
        >
          <Badge count={notifications.length} offset={[10, 0]}>
            <BellOutlined />
          </Badge>
        </Popover>
      ),
      style: {
        float: 'right'
      }
    }
  ]

  if (user.userData && !user.userData.isAuth) {
    return (
      <Menu mode = {props.mode} items={menuItems1} style={{ width:'250px'}}/>
    )
  } else if(user.userData && user.userData.isAuth) {
      return (
        <Menu mode = {props.mode} items={menuItems2} style={{width:"400px"}}/>
      )
  }else{
    return null;
  }
}
export default withRouter(RightMenu);

